export const systemHealthQueryKeys = ["systemHealthStatus"]